import { handleError } from '../common-message/message-action';
import { API_URL } from '../../../utils/config';
import { makeApiCall } from '../common/common-action';

//get all added cards
export function getAllCards() {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        url: `${API_URL}/card/list`,
        method: 'get',
        withCredentials: true
      });
      if (response && response.data && response.data.success && response.data.data) {
        return response.data.data;
      }
    } catch (error) {
      dispatch(handleError(error));
    }
    return [];
  };
}

//add new card
export function addNewCard(body, onClose) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        url: `${API_URL}/card/add`,
        method: 'post',
        data: body,
        withCredentials: true
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      onClose && onClose(true);
      dispatch(handleError(error));
    }
    return { success: false };
  };
}

//delete card
export function deleteCard(cardId, onClose, url) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        url: `${API_URL}/${url}${cardId}`,
        method: 'post',
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        return response.data.success;
      }
    } catch (error) {
      onClose && onClose(true);
      dispatch(handleError(error));
    }
    return false;
  };
}
